import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/inspectTaskError/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/inspectTaskError/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/inspectTaskError/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/inspectTaskError/submit', params, options);

export const update = (params, options) =>
  request.post('/api/inspectTaskError/submit', params, options);
